module.exports = "<h1>Username Sync</h1>\r\n\r\n<div class=\"alert alert-success\" *ngIf=\"success\">Success!</div>\r\n\r\n<h2>Sync Usernames</h2>\r\n<p>\r\n    This service looks up each Outcomes user record and references its ID with the account info service.\r\n    If the account is found, the username from the account info service will be \"synced\" to the Outcomes\r\n    database.\r\n</p>\r\n\r\n<button class=\"btn btn-primary\" (click)=\"doSync()\">Run</button>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/users/usersync.html
 ** module id = 678
 ** module chunks = 0
 **/